import React from 'react';
import * as css from './ProcessPopup.css';
import {StepItemProps} from './ProcessPopup.types';

function StepItem({step, index, isComplete, isCurrent, isClickable, onClick, dataCyName}: StepItemProps) {
    const className = [
        isComplete ? 'complete' : '',
        isCurrent ? 'current' : '',
        isClickable ? 'clickable' : 'disabled'
    ].filter(Boolean).join(' ');

    return (
        <css.step
            className={className}
            onClick={() => onClick(index)}
            aria-disabled={!isClickable}
            data-cy={`${dataCyName}Step${index}`}>
            <css.stepContent>
                <css.iconCircle>
                    {step.icon}
                </css.iconCircle>
                <css.stepLabel>{step.label}</css.stepLabel>
            </css.stepContent>
        </css.step>
    );
}

export default StepItem;

